import * as actionTypes from "./EnquiryType";

const INITIAL_STATE = {
  EnquiryList: null,
  sourceEnquiryList: [],
  EnquiryListById: {},
  CustomerList: {},
  categoryLists: [],
  EnquiryCount: [],
  EnquiryComments: [],
  EnquiryFollowupHistory: [],
  enquiryAttachmentData: [],
};

const EnquiryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETSOURCEENQUIRYLIST:
      return {
        ...state,
        sourceEnquiryList: action.payload.list.Data,
      };
    case actionTypes.SETENQUIRYLIST:
      return {
        ...state,
        EnquiryList: action.payload,
      };
    case actionTypes.SETENQUIRYLISTBYID:
      return {
        ...state,
        EnquiryListById: action.payload,
      };
    case actionTypes.SETENQUIRYCUSTOMERLIST:
      return {
        ...state,
        CustomerList: action.payload.list.Data,
      };
    case actionTypes.SETCATEGORY:
      return {
        ...state,
        categoryLists: action.payload.list.Data,
      };
    case actionTypes.SETENQUIRYCOUNT:
      return {
        ...state,
        EnquiryCount: action.payload,
      };
    case actionTypes.SETENQUIRYCOMMENTS:
      return {
        ...state,
        EnquiryComments: action.payload,
      };
    case actionTypes.SETENQUIRYFOLLWUPHISTORY:
      return {
        ...state,
        EnquiryFollowupHistory: action.payload,
      };
    case actionTypes.SETENQUIRYATTACHMENTDATA:
      return {
        ...state,
        enquiryAttachmentData: action.payload,
      };
    default:
      return state;
  }
};

export default EnquiryReducer;
